// UI ヘルパー
// XSS 対策: 動的データを HTML に挿入する際は必ず escapeHtml を通す (CLAUDE.md S3-4)

export function el(html) {
  const t = document.createElement('template');
  t.innerHTML = html.trim();
  return t.content.firstChild;
}

export function escapeHtml(str) {
  if (str === null || str === undefined) return '';
  const div = document.createElement('div');
  div.textContent = String(str);
  return div.innerHTML;
}

// ============ 画面遷移 ============
const SCREEN_ROOT = () => document.getElementById('screen-mount');
const HOME_ROOT = () => document.getElementById('screen-home');
let _backStack = ['home'];

export function showHome() {
  document.getElementById('app').classList.remove('app--map');
  HOME_ROOT().classList.add('screen--active');
  SCREEN_ROOT().innerHTML = '';
  _backStack = ['home'];
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

export function showScreen(name, content, opts = {}) {
  HOME_ROOT().classList.remove('screen--active');
  if (opts.fullbleed) {
    document.getElementById('app').classList.add('app--map');
  } else {
    document.getElementById('app').classList.remove('app--map');
  }
  const mount = SCREEN_ROOT();
  mount.innerHTML = '';
  const screen = document.createElement('main');
  screen.className = 'screen screen--active';
  screen.id = `screen-${name}`;
  screen.innerHTML = content;
  mount.appendChild(screen);
  if (_backStack[_backStack.length - 1] !== name) _backStack.push(name);
  window.scrollTo({ top: 0, behavior: 'instant' });
  return screen;
}

export function backToHome() {
  showHome();
}

export function screenHead(title, opts = {}) {
  const right = opts.right || '';
  return `
    <header class="screen-head">
      <button class="btn btn--icon" data-action="back" type="button" aria-label="戻る">
        <svg class="icon"><use href="#i-back"/></svg>
      </button>
      <h1 class="screen-head__title">${escapeHtml(title)}</h1>
      <div class="screen-head__action">${right}</div>
    </header>
  `;
}

// ============ Toast ============
let toastTimer = null;
export function toast(message, ms = 2400) {
  const t = document.getElementById('toast');
  t.textContent = message;
  t.hidden = false;
  if (toastTimer) clearTimeout(toastTimer);
  toastTimer = setTimeout(() => {
    t.hidden = true;
  }, ms);
}

// ============ Overlay (loading) ============
export function showLoading(message = '処理中…') {
  const ov = document.getElementById('overlay');
  document.getElementById('overlay-msg').textContent = message;
  ov.hidden = false;
}

export function hideLoading() {
  document.getElementById('overlay').hidden = true;
}

// ============ フォーマッタ ============
export function fmtDate(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d
    .toLocaleDateString('ja-JP', {
      timeZone: 'Asia/Tokyo',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })
    .replace(/\//g, '.');
}

export function fmtTime(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleTimeString('ja-JP', {
    timeZone: 'Asia/Tokyo',
    hour: '2-digit',
    minute: '2-digit',
  });
}

// 経過秒数を「Hh Mm」形式へ
export function fmtDuration(seconds) {
  if (!seconds || seconds < 0) return '0:00';
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);
  if (h > 0) return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  return `${m}:${String(s).padStart(2, '0')}`;
}

// メートル → 「km」or 「m」表示
export function fmtDistance(meters) {
  if (meters === null || meters === undefined || Number.isNaN(meters)) return '—';
  if (meters < 1000) return `${Math.round(meters)} m`;
  return `${(meters / 1000).toFixed(2)} km`;
}

// メートル → 標高表示(整数化)
export function fmtElevation(meters) {
  if (meters === null || meters === undefined || Number.isNaN(meters)) return '—';
  return `${Math.round(meters)} m`;
}

// PWA standalone 対応: ビューポート高さを取得して要素に設定
// iOS PWA では 100vh / 100dvh が機能しないため、window.innerHeight を直接使う
export function applyViewportHeight(el) {
  if (!el) return;
  const h = window.innerHeight || document.documentElement.clientHeight;
  el.style.height = `${h}px`;
}

// 地図のコントロール(ズーム・追従等)を map-data の上に動的配置
// map-data の高さは内容により変わるため、JS で実測して bottom を設定
export function adjustMapControls(stage) {
  if (!stage) return;
  const controls = stage.querySelector('.map-controls');
  if (!controls) return;
  const data = stage.querySelector('.map-data');
  if (data) {
    const h = data.getBoundingClientRect().height;
    controls.style.bottom = `${h + 16}px`;
  } else {
    controls.style.bottom = `calc(16px + env(safe-area-inset-bottom))`;
  }
}

// 緯度経度の有効性チェック
export function isValidLatLng(lat, lng) {
  return (
    typeof lat === 'number' &&
    typeof lng === 'number' &&
    !Number.isNaN(lat) &&
    !Number.isNaN(lng) &&
    lat >= -90 &&
    lat <= 90 &&
    lng >= -180 &&
    lng <= 180
  );
}

// ============ モーダル (window.confirm / prompt / alert の置換) ============
// 全てユーザーフレンドリーなボトムシートで実装

function buildModal(innerHtml) {
  const root = document.createElement('div');
  root.className = 'modal';
  root.innerHTML = `<div class="modal__backdrop"></div><div class="modal__sheet">${innerHtml}</div>`;
  document.body.appendChild(root);
  return root;
}

// アクションシート(ボタン選択)
//   title: 上部の見出し
//   body: 補足説明(省略可)
//   options: [{label, value, kind?}] kind = 'ink' | 'ghost' | 'warn' | 'warn-ink'
//   返却: 選択された option の value、背景タップ時は null
export function showActionSheet({ title, body, options }) {
  return new Promise((resolve) => {
    const buttons = options.map((o, i) => {
      const kindCls = o.kind ? `btn--${o.kind}` : '';
      return `<button class="btn ${kindCls} btn--block" data-idx="${i}" type="button">${escapeHtml(o.label)}</button>`;
    }).join('');
    const inner = `
      ${title ? `<p class="modal__title">${escapeHtml(title)}</p>` : ''}
      ${body ? `<p class="modal__body">${escapeHtml(body)}</p>` : ''}
      <div class="modal__actions">${buttons}</div>
    `;
    const root = buildModal(inner);
    const close = (v) => { root.remove(); resolve(v); };
    root.querySelectorAll('[data-idx]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const idx = parseInt(btn.dataset.idx, 10);
        close(options[idx].value);
      });
    });
    root.querySelector('.modal__backdrop').addEventListener('click', () => close(null));
  });
}

// 確認(2択: いいえ / はい)
//   返却: true / false
export function showConfirm({ title, body, confirmLabel = '実行', cancelLabel = 'キャンセル', destructive = false }) {
  return showActionSheet({
    title,
    body,
    options: [
      { label: cancelLabel, value: false, kind: 'ghost' },
      { label: confirmLabel, value: true, kind: destructive ? 'warn-ink' : 'ink' },
    ],
  });
}

// テキスト入力モーダル
//   返却: 入力された文字列、キャンセル時は null
export function showInputDialog({ title, body, initialValue = '', placeholder = '', multiline = false, confirmLabel = 'OK', cancelLabel = 'キャンセル' }) {
  return new Promise((resolve) => {
    const inputHtml = multiline
      ? `<textarea class="modal__textarea" placeholder="${escapeHtml(placeholder)}">${escapeHtml(initialValue)}</textarea>`
      : `<input class="modal__input" type="text" placeholder="${escapeHtml(placeholder)}" value="${escapeHtml(initialValue)}" />`;
    const inner = `
      ${title ? `<p class="modal__title">${escapeHtml(title)}</p>` : ''}
      ${body ? `<p class="modal__body">${escapeHtml(body)}</p>` : ''}
      ${inputHtml}
      <div class="modal__actions">
        <button class="btn btn--ink btn--block" data-confirm type="button">${escapeHtml(confirmLabel)}</button>
        <button class="btn btn--ghost btn--block" data-cancel type="button">${escapeHtml(cancelLabel)}</button>
      </div>
    `;
    const root = buildModal(inner);
    const input = root.querySelector(multiline ? '.modal__textarea' : '.modal__input');
    setTimeout(() => input.focus(), 50);

    const close = (v) => { root.remove(); resolve(v); };

    root.querySelector('[data-confirm]').addEventListener('click', () => close(input.value));
    root.querySelector('[data-cancel]').addEventListener('click', () => close(null));
    root.querySelector('.modal__backdrop').addEventListener('click', () => close(null));
    if (!multiline) {
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') close(input.value);
      });
    }
  });
}

// 通知モーダル(window.alert の置換)
export function showAlert({ title, body, label = 'OK' }) {
  return showActionSheet({
    title,
    body,
    options: [{ label, value: true, kind: 'ink' }],
  });
}

// クリップボードコピー(toast 付き)
export async function copyToClipboard(text, successMsg = 'コピーしました') {
  if (!text) return false;
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
    } else {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      ta.style.top = '0';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      document.execCommand('copy');
      ta.remove();
    }
    toast(successMsg);
    return true;
  } catch (e) {
    toast('コピーに失敗しました');
    return false;
  }
}
